export const ONLINE_QUESTION_ANSWER_STATUS_NO_INPUT = {
    label: '未入力',
    value: 1,
};
export const ONLINE_QUESTION_ANSWER_STATUS_INPUT = {
    label: '回答済み',
    value: 2,
};
export const ONLINE_QUESTION_ANSWER_STATUS_END = {
    label: '募集終了',
    value: 3,
};
export const ONLINE_QUESTION_ANSWER_STATUS = [
    ONLINE_QUESTION_ANSWER_STATUS_NO_INPUT,
    ONLINE_QUESTION_ANSWER_STATUS_INPUT,
];
export const ONLINE_QUESTION_ALL_ANSWER_STATUS = [
    ...ONLINE_QUESTION_ANSWER_STATUS,
    ...[ONLINE_QUESTION_ANSWER_STATUS_END],
];
